(function referenceGridInitLambda(global) {

  var TEMPLATES = {
    LINK_CELL: 'components/grid/linkCell.compile.html'
  };

  /**
   * Преобразует строку с правилами стиля в html стили.
   */
  global.getReferenceRecordStyle = function (styleRules) {
    var style = "";

    // По умолчанию цвет белый, не нужно его прописывать чтобы не ломать темы пользователя.
    if (styleRules.TextColor.R + styleRules.TextColor.G + styleRules.TextColor.B > 0)
      style = format("color: rgb({0},{1},{2}) !important;",
        styleRules.TextColor.R,
        styleRules.TextColor.G,
        styleRules.TextColor.B);

    if (styleRules.IsBold)
      style = style + "font-weight: bold;";

    if (styleRules.IsItalic)
      style = style + "font-style: italic;";

    if (styleRules.IsStrikeOut)
      style = style + "text-decoration: line-through;";

    return style;
  };

  /**
  * Обновить данные в форме-список справочника.
  */
  global.forceReloadData = () => {
    setTimeout(() => {
      // QueryInstanceID берем из текущего состояния грида в случае если справочник открыли как результат сценария (ориентируемся на параметр uid в урле).
      global.reference.updateState({ QueryInstanceID: ((new WA.URL).getParam('uid')) ? global.reference.state.QueryInstanceID : generateUniqueID() }, true);
      global.reference.reloadData();
    }, 0);
  };

  global.initReference = function (referenceName, referenceView, placementContext, columns, state) {
    // Создает объект для формирования ссылки на запись справочника.
    var createReferenceRecordObj = function (id) {
      return { id: id, kind: "REF", refcode: referenceName, refview: referenceView };
    };

    // Дополнительная информация по строке записи справочника.
    var getReferenceRecordRowAdditionalInfo = function (rowNumber, grid) {
      var row = this.getItem(rowNumber);
      if (row.__nonDataRow !== true) {
        var backgroundColor = "";

        if (row.styleRules) {
          var backgroundColorObj = JSON.parse(row.styleRules).BackgroundColor;
          // По умолчанию цвет белый, не нужно его прописывать чтобы не ломать темы пользователя.
          // TODO сделать цвет выделения ячейки смещением от текущего цвета.
          if (backgroundColorObj.R + backgroundColorObj.G + backgroundColorObj.B < 765) {
            backgroundColor = format("background: rgb({0},{1},{2}) !important;",
              backgroundColorObj.R,
              backgroundColorObj.G,
              backgroundColorObj.B);
          }
        }

        return {
          cssClasses: 'List ' + (Core.grid.reference.grid.getSelectedRows().indexOf(rowNumber) !== -1 ? 'selected' : ''), //FIXME
          backgroundColor: backgroundColor,
          attributes: {
            'id': row.id,
            'kind': 'REF',
            'compcode': referenceName,
            'data-recid': row.id,
            'data-refcode': referenceName,
            'oncontextmenu': 'var event = arguments[0] || window.event; return Core.grid.reference.openContextMenu(this, event);'
          }
        };
      }
    };

    let sourceTabName = '';
    WA.ready(function () {
      // Событие должно отрабатывать только для той вкладки, на которой оно было добавлено.
      // Если убрать эту проверку, то при переходе со вкладки, где есть грид на реактивную вкладку Истории,
      // вместо истории мы увидим грид =) В дальнейшем нужно будет пофиксить с полным переходом на React.
      const sidebarTabs = WA.CR.sideBar.tabs.toArray();
      if (sidebarTabs.length) {
        if (!sourceTabName) {
          sourceTabName = WA.CR.sideBar.tabs.current.name;
        } else if (sourceTabName !== WA.CR.sideBar.tabs.current.name) {
          return ;
        }
      }

      WA.templates.load(TEMPLATES.LINK_CELL).done(function (cellTemplate) {

        var DV = WA.CMP.dataViews;

        var plugins = [
          new DV.gridPlugins.SortingPlugin(true),
          new DV.gridPlugins.GroupingPlugin(),
          new DV.gridPlugins.FooterPlugin(),
          new DV.gridPlugins.CheckboxPlugin(),
          new DV.gridPlugins.ContextMenuPlugin({ from: 'ReferenceTable', refview: referenceView }),
          new DV.gridPlugins.ColumnResizePlugin(),
          new DV.gridPlugins.FilteringPlugin(global.SelectListDataProvider)
        ];

        var dataSource = new global.ReferenceDataSource(referenceName, referenceView, placementContext, state);

        // Шаблонизатор ячеек.
        var referenceRecordsCellTemplate = function (rowNumber, cellNumber, value, columnDef, dataContext) {
          var recID = dataContext.id;
          value = value || '';

          switch (columnDef.id) {
            case '_ContextMenu':
              // Метод openContextMenu находится в плагине gridPlugins.ContextMenuPlugin.
              return '<svg class="slick-cell__menu" onclick="return Core.grid.reference.openContextMenu(this, event)"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#hamburger-20"></use></svg>';
            case '_Checkbox':
              // Для этой колонки подключается спец. плагин gridPlugins.CheckboxPlugin.
              break;
            default:
              var href = GetObjectCardUrl(createReferenceRecordObj(recID));
              // Подсказка.
              var hint = {
                classes: '',
                data: ''
              };

              if (columnDef.hint) {
                var columnRecId = dataContext[columnDef.id];
                hint.classes = 'hint';
                hint.data = 'data-hint="' + columnDef.hint.replace('%REC_ID%', recID).replace('%REQ_ID%', columnRecId) + '"';
              }

              var style = "";
              if (dataContext['styleRules']) {
                style = global.getReferenceRecordStyle(JSON.parse(dataContext['styleRules']));
              }

              var target = "Ref" + recID;

              return cellTemplate.render({
                style: style,
                hint: hint,
                value: value,
                href: href,
                target: target
              });
          }
        };

        var referenceGrid = new DV.Grid('#main_container', dataSource, columns, {
          getRowAdditionalInfo: getReferenceRecordRowAdditionalInfo,
          cellTemplate: referenceRecordsCellTemplate,
          plugins: plugins,
          selectListDataProviderSettings: {
            referenceName: referenceName,
            referenceView: referenceView,
            filter: state.GlobalPageFilterLikeQuery,
            queryInstanceID: state.QueryInstanceID,
            queryContext: state.QueryContext
          }
        });

        // Для работы клиентской ОМ.
        var notifyObjectList = function () {
          WA.ObjectListInit.done(function () {
            WA.CR.objectList.fire('itemsChange');
          });
        };
        referenceGrid.bind(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, notifyObjectList).bind(WA.CMP.DV.Grid.EVENT.SELECTED_ROWS_CHANGED, notifyObjectList);

        referenceGrid.bind(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, function () {
          // Инициализируем подсказки к объектам системы.
          InitTooltips();
        });
        referenceGrid.bind(WA.CMP.DV.Grid.EVENT.VIEWPORT_CHANGED, function () {
          // Инициализируем подсказки к объектам системы при скроллинге.
          InitTooltips();
        });

        referenceGrid.bind(WA.CMP.DV.Grid.EVENT.PAGE_CHANGE, function () {
          // Инициализируем подсказки к объектам системы при скроллинге.
          InitTooltips();
        });


        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
        // Публичные объекты.
        global.reference = referenceGrid;
        global.referenceInit.resolve();
        //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      });
    });
  }

})(window.Core.grid);
